import React from 'react';
import '../../../assets/stylesheets/ClubSlide/NewTable.scss';
import Header from '../../Units/Header';
import { Link, useParams } from 'react-router-dom';

const tableTypes = ['nlh', 'plo'];

const CreateTable = () => {
    const {id: clubId} = useParams();
    return (
        <div className={`createNewTable`}>
            <Header backTo={`/club/${clubId}`}/>
            { tableTypes.map( type => 
                (<Link
                    to = {{ pathname: `/club/${clubId}/${type}`, type: type }} key={type} className={`${type}`}>
                </Link>)
            )}
        </div>
    );
};

export default CreateTable;